export default __webpack_public_path__ + "static/media/empty-cart.628fe371.png";